module.exports = __webpack_public_path__ + "static/media/4ODA1.d4e4be38.jpg";